export const BILLING_STATE_OPTIONS = [
  { label: "Andaman and Nicobar Islands", value: 35 },
  { label: "Andhra Pradesh", value: 37 },
  { label: "Arunachal Pradesh", value: 12 },
  { label: "Assam", value: 18 },
  { label: "Bihar", value: 10 },
  { label: "Chandigarh", value: 4 },
  { label: "Chhattisgarh", value: 22 },
  { label: "Dadra and Nagar Haveli and Daman and Diu", value: 26 },
  { label: "Delhi", value: 7 },
  { label: "Goa", value: 30 },
  { label: "Gujarat", value: 24 },
  { label: "Haryana", value: 6 },
  { label: "Himachal Pradesh", value: 2 },
  { label: "Jammu and Kashmir", value: 1 },
  { label: "Jharkhand", value: 20 },
  { label: "Karnataka", value: 29 },
  { label: "Kerala", value: 32 },
  { label: "Ladakh", value: 38 },
  { label: "Lakshadweep", value: 31 },
  { label: "Madhya Pradesh", value: 23 },
  { label: "Maharashtra", value: 27 },
  { label: "Manipur", value: 14 },
  { label: "Meghalaya", value: 17 },
  { label: "Mizoram", value: 15 },
  { label: "Nagaland", value: 13 },
  { label: "Odisha", value: 21 },
  { label: "Puducherry", value: 34 },
  { label: "Punjab", value: 3 },
  { label: "Rajasthan", value: 8 },
  { label: "Sikkim", value: 11 },
  { label: "Tamil Nadu", value: 33 },
  { label: "Telangana", value: 36 },
  { label: "Tripura", value: 16 },
  { label: "Uttar Pradesh", value: 9 },
  { label: "Uttarakhand", value: 5 },
  { label: "West Bengal", value: 19 },
];

export const BILLING_STATE_VALUE_LABEL_MAP = BILLING_STATE_OPTIONS.reduce(
  (response, { label, value }) => {
    response[value] = label;
    return response;
  },
  {}
);
